import React from 'react';

import '../styles/antd.less';
import '../styles/antd-restyle.less';
import '../styles/index.less';

export function CssFramework({children}) {
  return <React.Fragment>{children}</React.Fragment>;
}